//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'
import { wxApi } from '@/api'
import Download from '@/components/common/Download';
export default {
  name: 'app',
  components:{
    Download
  },
  data(){
    return{
      isShow:false
    }
  },
  created(){
    // this.isShow = this.isApp ? false :true
  },
  computed:{
    isApp(){
      return this.$utils.os() == 'androidApp' || this.$utils.os() == 'iosApp' ? true : false;
    },
    ...mapState({
       direction: state => state.vux.direction
    }),
     ...mapState('myself',{
       myinfo: state => state.myinfo
    }),
    ...mapState('keep',{
       keepList: state => state.keepList
    }),
    viewTransition () {
      if (!this.direction) return ''
      return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
    },
    os(){
      const ua = window.navigator.userAgent;
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1; //g
      const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' || ua.toLowerCase().indexOf(' qq')>-1 && ua.toLowerCase().indexOf('mqqbrowser') <0){
          this.isWx = true;
          return 'wxORqq'
      }else{
          if(isAndroid){
              return 'android'
          }else if(isIOS){
              return 'ios'
          }else{
              return 'other'
          }
      }
    }
  },
  mounted(){
    this.disableZoom();
    if(this.$route.name == 'TravelFindDetail' || this.$route.name == 'InviteFriend' || this.$route.name == 'InviteDownload' || this.$route.name == 'BrowserIndex' || this.$route.name == 'Invite' || this.$route.name == 'Activity' || this.$route.name == 'CulturaDetail' || this.$route.name == 'TravelGuide' || this.$route.name == 'TravelLine' || this.$route.name == 'UserIndex' || this.$route.name == 'VideoIndex'){

    }else{
      sessionStorage.getItem('token') ? this.setMyself() : '';
      switch (this.$utils.judgeBrowser()) {
        case 1:
          this.share();
          break;
        case 2:
          this.qqShare();
          break;
        default:

          break;
      }
    }
  },
  updated(){
    if(this.$route.name == 'TravelFindDetail' || this.$route.name == 'InviteFriend' || this.$route.name == 'InviteDownload' || this.$route.name == 'BrowserIndex' || this.$route.name == 'Invite' || this.$route.name == 'Activity' || this.$route.name == 'CulturaDetail' || this.$route.name == 'TravelGuide' || this.$route.name == 'TravelLine' || this.$route.name == 'UserIndex' || this.$route.name == 'VideoIndex' || this.$route.name == 'Classify'){

    }else{
      sessionStorage.getItem('token') ? this.setMyself() : '';
      switch (this.$utils.judgeBrowser()) {
        case 1:
          this.share();
          break;
        case 2:
          this.qqShare();          
          break;
        default:

          break;
      }
    }
  },
  methods:{
    ...mapActions('myself',{
      setMyself:'setMyInfoAction'
    }),
    disableZoom(){
      switch (this.os) {
        case 'wxORqq':
          if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
              this.handleFontSize();
          } else {
              document.addEventListener("WeixinJSBridgeReady", this.handleFontSize, false);
          }
          break;
        case 'ios':
          break;
        default:
          let $dom = document.createElement('div');
          $dom.style = 'font-size:10px;';
          document.body.appendChild($dom);
          // 计算出放大后的字体
          let scaledFontSize = parseInt(window.getComputedStyle($dom, null).getPropertyValue('font-size'));
          document.body.removeChild($dom);
          // 计算原字体和放大后字体的比例
          let scaleFactor = 10 / scaledFontSize;

          // 取html元素的字体大小
          // 注意，这个大小也经过缩放了
          // 所以下方计算的时候 *scaledFontSize是原来的html字体大小
          // 再次 *scaledFontSize才是我们要设置的大小
          let originRootFontSize = parseInt(window.getComputedStyle(document.documentElement, null).getPropertyValue('font-size'));
          document.documentElement.style.fontSize = originRootFontSize * scaleFactor * scaleFactor + 'px';
          break;
      }
       
    },
    handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        });
    },
    qqShare(){
      let $this=this;
      wxApi().then(res=>{
        console.log(res);
        if(res.code == 0){
          setShareInfo({
              title:          '旅享视界', // 分享标题
              summary:        '诗和远方，理想生活！全球专业文化和旅游短视频服务平台！', // 分享内容
              pic:            `${$this.$utils.dominame}/logo_red.png`, // 分享图片
              url:            `${$this.$utils.dominame}${$this.$route.fullPath}`, // 分享链接
              // 微信权限验证配置信息，若不在微信传播，可忽略
              WXconfig: {
                  swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                  appId: res.data.appid, // 公众号的唯一标识
                  timestamp: res.data.timestamp, // 生成签名的时间戳
                  nonceStr: res.data.noncestr, // 生成签名的随机串
                  signature: res.data.signature // 签名
              }
          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
    share(){
      let $this=this;
        wxApi().then(res=>{
            console.log(res);
            this.$wx.config({
                debug: false,
                appId: res.data.appid,
                timestamp: res.data.timestamp,
                nonceStr: res.data.noncestr,
                signature: res.data.signature,
                jsApiList:['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareQZone']
            });
            this.$wx.ready(function () {
                $this.$wx.onMenuShareAppMessage({
                    title:'旅享视界', // 分享标题
                    desc:'诗和远方，理想生活！全球专业文化和旅游短视频服务平台！', // 分享描述
                    link: `${$this.$utils.dominame}${$this.$route.fullPath}`, // 分享链接
                    imgUrl: require('@/assets/img/logo_red.png'), // 分享图标
                    type: '', // 分享类型,music、video或link，不填认默为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                });
                $this.$wx.onMenuShareTimeline({
                    title:'旅享视界', // 分享标题
                    link:`${$this.$utils.dominame}${$this.$route.fullPath}`, // 分享链接
                    imgUrl:require('@/assets/img/logo_red.png'), // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                    }
                });
                $this.$wx.onMenuShareQQ({
                  title: '旅享视界', // 分享标题
                  desc: '诗和远方，理想生活！全球专业文化和旅游短视频服务平台！', // 分享描述
                  link: `${$this.$utils.dominame}${$this.$route.fullPath}`, // 分享链接
                  imgUrl: require('@/assets/img/logo_red.png'), // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                $this.$wx.onMenuShareQZone({
                  title: '旅享视界', // 分享标题
                  desc: '诗和远方，理想生活！全球专业文化和旅游短视频服务平台！', // 分享描述
                  link: `${$this.$utils.dominame}${$this.$route.fullPath}`, // 分享链接
                  imgUrl: require('@/assets/img/logo_red.png'), // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
            });
        }).catch(err=>{
            console.log(err);
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/App.vue